import { Typography } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import dayjs from 'dayjs';
import { t } from 'i18next';

import { WarningCell } from 'core/elements';
import { WarningType } from 'core/enums';
import { formatDate, getAgGridTableCellData } from 'core/utils';
import { QuotePartColId } from 'quotes/components/QuotePartList';
import { IQuotePart } from 'quotes/types';
import { Level } from 'theme/enums';

export const PricingDateCell = (props: ICellRendererParams) => {
  const data = getAgGridTableCellData(props, QuotePartColId.PRICING_DATE);

  if (!data) {
    return props?.value;
  }

  const { pricingDate } = data as IQuotePart;

  if (!pricingDate) {
    return (
      <Typography level={Level.BODY_SM} sx={{ color: 'neutral.500' }}>
        {t('labelCurrentDate')}
      </Typography>
    );
  }

  const isExpired = dayjs(pricingDate).isBefore(dayjs(), 'day');

  return (
    <WarningCell
      content={formatDate(pricingDate)}
      showWarning={isExpired}
      type={WarningType.WARNING}
      sx={{ justifyContent: 'flex-start' }}
    />
  );
};
